// The `popover-popup` transition in index.css derives its duration from the popup's height, as
// MUI's Grow did. Base UI writes no height variable for these popups, so each one measures itself:
// on mount, before the opening transition starts (offsetHeight ignores the starting scale), and
// again as it closes, for content that grew or shrank while it was open.
export const writePopupHeight = (popup: HTMLElement): void =>
  popup.style.setProperty('--popover-height-px', `${popup.offsetHeight}px`);
